export default "__VITE_ASSET__DH1CPzfn__"